module.exports = __webpack_public_path__ + "img/Bg-White.332ecefe.svg";